import React, { useState } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import "./style.css";

function Menu({ isVisible, children, menuItems, onMenuItemClick }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div
      className={classnames({
        hide: !isVisible
      })}
    >
      <div className="menu-label" onClick={() => setIsMenuOpen(!isMenuOpen)}>
        {children}
      </div>
      <ul
        className={classnames("menu-item-wrapper", {
          hide: !isMenuOpen
        })}
      >
        {/* Display the menu items */}
        {Array.isArray(menuItems) &&
          menuItems.length &&
          menuItems.map(item => (
            <li
              key={item.id}
              className={`menu-item pointer ${item.classNames}`}
              onClick={() => {
                onMenuItemClick(item);
                setIsMenuOpen(!isMenuOpen);
              }}
            >
              {item.iconClass ? <i className={item.iconClass}></i> : ""}
              {item.label}
            </li>
          ))}
      </ul>
    </div>
  );
}

Menu.propType = {
  isVisible: PropTypes.bool.isRequired,
  children: PropTypes.any.isRequired,
  onMenuItemClick: PropTypes.func.isRequired,
  menuItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.any.isRequired,
      label: PropTypes.string.isRequired,
      classNames: PropTypes.string,
      iconClass: PropTypes.string
    })
  )
};

export default Menu;
